import React from "react";
import {Button} from "primereact/button";
import Icon from "../../../system/components/icon";
import {steps} from "../utils/product-brief-schema";

export default function BriefStepper({activeStep, setActiveStep, translate}) {
    return (
        <nav className="pbb-stepper" aria-label={translate("pbb-steps")}>
            {steps.map((step, index) => (
                <Button
                    key={step.id}
                    type="button"
                    text
                    className={`pbb-step ${activeStep === index ? "active" : ""}`}
                    onClick={() => setActiveStep(index)}
                >
                    <span>{index + 1}</span>
                    <strong>{translate(step.titleKey)}</strong>
                    {activeStep === index && <Icon icon="mi mi:edit_note" size={18}/>}
                </Button>
            ))}
        </nav>
    );
}
